import React, { useState, useEffect } from 'react';
import MaterialTable from 'material-table';
import BackButton from '../../items/buttons/BackButton';
import LoadingIcon from '../../items/buttons/LoadingIcon';
import AddLabel from './addLabel';
import Swal from 'sweetalert2';
import request from '../../../services/Request';
import { userLimits } from '../uitls/userLimits';

const getLabelsURL = `/labels/`;
const deleteLabelsURL = `/labels/delete/`;

export default function Label(props) {
  const { _id, tableTitle, superAdmin, access } = userLimits(
    props.match.params.id,
    props.match.params.group,
    'Labels',
    'edit_cate'
  );
  const [reflesh, setReflesh] = useState(false);
  const [labels, setLabels] = useState([]);
  const [loading, setLoading] = useState(false);

  const [show, setShow] = useState(false);
  const [id, setID] = useState('');
  const [update, setUpdate] = useState(false);
  const [name, setName] = useState('');

  const [pagination, setPagination] = useState(
    localStorage.getItem('table_view_label') ? localStorage.getItem('table_view_label') : 5
  );

  useEffect(() => {
    localStorage.setItem('table_view_label', pagination);
  }, [pagination]);

  useEffect(() => {
    let isCancelled = false;

    async function getMyLabels() {
      await request({
        method: 'get',
        url: !props.match.params.group && superAdmin ? getLabelsURL : getLabelsURL + _id,
      }).then((res) => {
        if (!isCancelled) {
          console.log(res.data);
          setLabels(res.data);
          setLoading(true);
        }
      });
    }
    getMyLabels();

    return () => {
      isCancelled = true;
    };
  }, [reflesh]);

  const deleteLabel = async (id) => {
    setLoading(false);
    await request({
      method: 'delete',
      url: deleteLabelsURL + id,
    }).then(() => {
      setLoading(true);
    });
    reflesh ? setReflesh(false) : setReflesh(true);
  };

  const columns = [
    { title: 'Label Name', field: 'name.en' },
  ];

  return (
    <div>
      {!loading && <LoadingIcon />}
      <div style={{ maxWidth: '100%' }}>
        <MaterialTable
          onChangeRowsPerPage={setPagination}
          columns={columns}
          data={labels}
          title={tableTitle}
          editable={
            access && {
              onRowDelete: (newData, oldData) =>
                new Promise((resolve, reject) => {
                  setTimeout(() => {
                    deleteLabel(newData._id);
                    Swal.fire({
                      text: `A label has been successfully deleted: ${newData.name.en}`,
                      icon: 'success',
                    });
                    resolve();
                  }, 1000);
                }),
            }
          }
          actions={[
            access && {
              icon: 'add',
              tooltip: 'Add Label',
              isFreeAction: true,
              onClick: (event) => {
                setUpdate(false);
                setShow(true);
              },
            },
            access && {
              icon: 'edit',
              tooltip: 'Edit Label',
              onClick: (event, rowData) => {
                setID(rowData._id);
                setName(rowData.name);
                setUpdate(true);
                setShow(true);
              },
            },
          ]}
          options={{
            actionsColumnIndex: -1,
            pageSize: parseInt(pagination),
            pageSizeOptions: [10, 20, 50, 100],
          }}
        />
        <BackButton />
        <AddLabel
          referTo={_id}
          id={id}
          show={show}
          name={name}
          reflesh={reflesh}
          setReflesh={setReflesh}
          update={update}
          onHide={() => setShow(false)}
        />
      </div>
    </div>
  );
}